import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Country, CountryCreate, CountryFilter } from '../data/country';

export function createCountryService(client: AxiosInstance) {
  return createCrudService<Country, CountryCreate, CountryFilter>(
    client,
    '/master-data/Country',
    'id',
  );
}

export type CountryService = CrudService<Country, CountryCreate, CountryFilter>;
